import React, { useState, useEffect } from "react";
import "../styles/main.css";
import Images from "./images";

import bg1 from "../assets/bgi1.jpg";
import bg2 from "../assets/bgi3.png";
import bg3 from "../assets/bgi3.png";
// import { position } from "html2canvas/dist/types/css/property-descriptors/position";

const Mainbg2 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const storyDuration = 5000;
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    setAnimating(false);
    const timeout = setTimeout(() => setAnimating(true), 50);
    return () => clearTimeout(timeout);
  }, [currentIndex]);

  const backgrounds = [bg1, bg2, bg3];

  const slides = [
    { image: bg1, size: "cover", bgColor: "#000", position: "center" },
    { image: bg2, size: "contain", bgColor: "#000", position: "top" },
    { image: bg3, size: "contain", bgColor: "#FFF753", position: "top" },
  ];

  // Auto slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % backgrounds.length);
    }, storyDuration);

    return () => clearInterval(interval);
  }, []);

  return (
<div
  className="relative bg-black mt-[-100px] w-full min-h-screen p-6 flex flex-col pt-20 sm:pt-10 px-10 sm:px-5 bg-no-repeat bg-center bg-cover transition-all duration-700"
  style={{
    backgroundImage: `url(${slides[currentIndex].image})`,
    backgroundSize: slides[currentIndex].size,
    backgroundColor: slides[currentIndex].bgColor,
  }}
>
  {/* Darken first hero background with vignette overlay only */}
  {currentIndex === 0 && (
    <div
      className="absolute inset-0 pointer-events-none z-0"
      style={{
        // Vignette: darker toward edges/corners, lighter in the center for text readability.
        background:
          "radial-gradient(ellipse at center, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.85) 100%)",
      }}
    />
  )}

  {/* Darken third hero background only for readability over busy imagery */}
  {currentIndex === 2 && (
    <div
      className="absolute inset-0 pointer-events-none z-0"
      style={{
        background:
          "radial-gradient(ellipse at center, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0.4) 45%, rgba(0,0,0,0.72) 100%)",
      }}
    />
  )}

  {/* Center Content */}
  <div className="relative z-10 mt-32 flex flex-col items-center px-4">
        <h1
          style={{ fontFamily: "Norwester" }}
          // className="text-[64px] text-[#FFF528] text-center max-w-4xl leading-[80px]"
          className={`text-[58px] text-[#FFF528] mb-2 xl:text-[50px] text-center lg:text-5xl sm:text-2xl md:text-2xl max-w-7xl xl:max-w-4xl  leading-[90px] xl:leading-[80px] lg:leading-[80px] sm:leading-10 md:leading-10 sm:mt-10 ${
            currentIndex === 2 ? "text-white" : "text-[#FFF528]"
          }`}
        >
          Unleash the Power of Fan Content in Sports Broadcasting
        </h1>

        <p className="font-Inter font-medium text-center text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] text-white/90 mb-10 max-w-5xl lg:max-w-2xl md:max-w-xl sm:max-w-xs leading-relaxed">
          Transform your broadcasts with authentic fan perspectives and expand
          your audience engagement
        </p>

        {/* App Store Buttons */}
        <div className="inline-grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2.5 mx-auto px-2 sm:w-full sm:max-w-[190px]">
          {/* Get for iPhone */}
          <a
            href="https://apps.apple.com/app/vupop/id6747295116"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#FFF523] hover:brightness-90 hover:shadow-xl active:scale-[0.98] transition-all duration-200
                   w-full min-w-0 overflow-hidden
                   px-5 py-2.5 md:px-4 md:py-2.5 sm:px-3 sm:py-2.5
                   rounded-xl shadow-lg
                   flex items-center justify-center gap-2 sm:gap-2
                   sm:min-h-[44px]"
          >
            <svg
              className="w-7 h-7 shrink-0 md:w-6 md:h-6 sm:w-5 sm:h-5"
              viewBox="0 0 24 24"
              fill="#1A1A1A"
              aria-hidden="true"
            >
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
            </svg>
            <span className="font-league-spartan font-semibold uppercase tracking-wide sm:tracking-normal text-[#1A1A1A] text-base md:text-sm sm:text-xs whitespace-nowrap">
              Get for iPhone
            </span>
          </a>

          {/* Get it on Android */}
          <a
            href="https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#FFFFFF] hover:brightness-90 hover:shadow-xl active:scale-[0.98] transition-all duration-200
                   w-full min-w-0 overflow-hidden
                   px-5 py-2.5 md:px-4 md:py-2.5 sm:px-3 sm:py-2.5
                   rounded-xl shadow-lg
                   flex items-center justify-center gap-2 sm:gap-2
                   sm:min-h-[44px]"
          >
            <svg
              className="w-7 h-7 shrink-0 md:w-6 md:h-6 sm:w-5 sm:h-5"
              viewBox="0 0 24 24"
              fill="#1A1A1A"
              aria-hidden="true"
            >
              <path d="M17.523 15.341c-.551 0-.999-.448-.999-.999s.448-.999.999-.999.999.448.999.999-.448.999-.999.999m-11.046 0c-.551 0-.999-.448-.999-.999s.448-.999.999-.999.999.448.999.999-.448.999-.999.999m11.404-6.02l1.997-3.459a.416.416 0 0 0-.152-.567.416.416 0 0 0-.567.152l-2.022 3.503A12.497 12.497 0 0 0 12 8.436c-1.856 0-3.595.403-5.137 1.114L4.841 6.047a.416.416 0 0 0-.567-.152.416.416 0 0 0-.152.567l1.997 3.459C2.688 11.186.857 14.201.857 17.633h22.286c0-3.432-1.831-6.447-5.262-8.312" />
            </svg>
            <span className="font-league-spartan font-semibold uppercase tracking-wide sm:tracking-normal text-[#1A1A1A] text-base md:text-sm sm:text-xs whitespace-nowrap">
              Get it on Android
            </span>
          </a>
        </div>

        {/* Images + Counter */}
        <div className="flex flex-row pt-8 gap-6 items-center justify-center mb-20">
          <Images />
          <div className={`h-[72px] w-[2px] bg-[#FFF528] ${
            currentIndex === 2 ? "bg-black" : "bg-[#FFF528]"
          }`}></div>
          <div className="flex flex-col justify-center leading-tight">
            <p className={`text-[#FFF528] sm:text-sm md:text-[16px] lg:text-lg text-[20px] font-semibold ${
            currentIndex === 2 ? "text-black" : "text-[#FFF528]"
          } `}>
              3000+
            </p>
            <p className={`text-[#FFF528] text-xs sm:text-xs md:text-sm lg:text-[16px] text-[18px] ${
            currentIndex === 2 ? "text-black" : "text-[#FFF528]"
          }`}>on Waitlist</p>
          </div>
        </div>

        {/* Progress Bars */}
        {/* <div className="absolute bottom-10 left-0 right-0 flex justify-center">
          <div className="flex gap-3">
            {[0, 1, 2].map((index) => (
              <div
                key={index}
                className="w-[198px] sm:w-[98px] h-2 bg-white/30 rounded-full overflow-hidden"
              >
                <div
                  className={`h-full bg-white transition-all duration-[5000ms] ${
                    index === currentIndex
                      ? "w-full"
                      : index < currentIndex
                      ? "w-full"
                      : "w-0"
                  }`}
                />
              </div>
            ))}
          </div>
        </div> */}

        {/* Progress Bars */}
        <div className="absolute bottom-10 left-0 right-0 flex justify-center">
          <div className="flex gap-3">
            {[0, 1, 2].map((index) => (
              <div
                key={index}
                className="w-[198px] sm:w-[98px] h-2 bg-white/30 rounded-full overflow-hidden"
              >
                <div
                  className={`h-full bg-white transition-all duration-[5000ms] ease-linear ${
                    index < currentIndex
                      ? "w-full"
                      : index === currentIndex &&
                          (currentIndex > 0 || animating)
                        ? "w-full"
                        : "w-0"
                  }`}
                  style={{
                    transition:
                      index === currentIndex ? "width 5000ms linear" : "none",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mainbg2;
